export default __webpack_public_path__ + "static/media/avatar.587c04b5.png";